import { useNavigate, useLocation } from 'react-router';
import { Btn } from '../components/chrome/Buttons.js';
import { ROSTER } from '../data/roster.js';

interface ResultState {
  won: boolean;
  myCount: number;
  opponentCount: number;
}

export function GameOver() {
  const nav = useNavigate();
  const { state } = useLocation();
  const r = (state ?? { won: false, myCount: 0, opponentCount: 0 }) as ResultState;
  return (
    <div className="gameover fade-in">
      <div className="gameover-tag">Match Result</div>
      <div className={`verdict ${r.won ? '' : 'lost'}`}>{r.won ? 'VICTORY' : 'DEFEAT'}</div>
      <div className="stat-line">
        <div>
          <div className="s">You</div>
          {r.myCount}
        </div>
        <div className="dash">—</div>
        <div>
          <div className="s">CPU</div>
          {r.opponentCount}
        </div>
      </div>
      <div className="lineup">
        {ROSTER.slice(0, r.won ? 8 : 4).map((w) => (
          <div
            key={w.id}
            className="mini"
            style={{ background: `linear-gradient(160deg, ${w.accent2}, ${w.accent})` }}
          />
        ))}
      </div>
      <div className="gameover-cta">
        <Btn variant="secondary" onClick={() => nav('/menu')}>
          MENU
        </Btn>
        <Btn variant="primary" onClick={() => nav('/battle/cpu', { replace: true })}>
          REMATCH
        </Btn>
      </div>
    </div>
  );
}
